import { Moment } from 'moment'

import usePrevious from 'hooks/usePrevious'
import { BookmarkDatesAndOccupancy } from 'tripPlanner/types/tripItem'

const datesAvailable = (datesAndGuests: BookmarkDatesAndOccupancy): boolean =>
  typeof datesAndGuests.checkInDate !== 'undefined' &&
  typeof datesAndGuests.checkOutDate !== 'undefined'

const hasDateChanged = (a: Moment, b: Moment): boolean => !a.isSame(b)

export const useDatesOrGuestsChanged = (
  current: BookmarkDatesAndOccupancy,
): boolean => {
  const previous = usePrevious(current, current)

  const checkInChanged =
    !!current.checkInDate &&
    (!previous.checkInDate ||
      hasDateChanged(current.checkInDate, previous.checkInDate))
  const checkOutChanged =
    !!current.checkOutDate &&
    (!previous.checkOutDate ||
      hasDateChanged(current.checkOutDate, previous.checkOutDate))

  return (
    datesAvailable(current) &&
    (current.durationInDays !== previous.durationInDays ||
      current.occupancies !== previous.occupancies ||
      checkInChanged ||
      checkOutChanged)
  )
}
